'use client';

import { Ccontainer } from '@/components/ui/Ccontainer';
import { ContainerPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme';
import type { WitnessCardData } from '@/components/ui/Cwitnesscard';
import { CwitnesscardmodalBackButton } from './CwitnesscardmodalBackButton';
import { CwitnesscardmodalContentPanel } from './CwitnesscardmodalContentPanel';
import { CwitnesscardmodalImagePanel } from './CwitnesscardmodalImagePanel';
import { getCwitnesscardmodalBoxShadow } from './cwitnesscardmodalStyles';

interface CwitnesscardmodalSurfaceProps {
  card: WitnessCardData;
  isMobile: boolean;
  onClose: () => void;
}

export function CwitnesscardmodalSurface({
  card,
  isMobile,
  onClose,
}: CwitnesscardmodalSurfaceProps) {
  return (
    <Ccontainer
      rootAttributes={{ "data-el": "Cwitnesscardmodal/Surface/Root" }}
      preset={ContainerPreset.WitnessCard}
      borderColor={ColorType.Accent}
      borderOpacity={0.14}
      borderWidth={1}
      innerBorder={false}
      width="100%"
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      boxShadow={getCwitnesscardmodalBoxShadow(isMobile)}
    >
      <CwitnesscardmodalBackButton onClose={onClose} />
      <CwitnesscardmodalImagePanel card={card} isMobile={isMobile} />
      <CwitnesscardmodalContentPanel card={card} isMobile={isMobile} />
    </Ccontainer>
  );
}
